<template>
  <v-row>
    <v-col cols="12">
      <v-card>
        <v-card-text class="pt-0">
          <v-row dense>
            <v-col>
              <v-card-title class="px-0">
                Annual Review Spotlight
              </v-card-title>
            </v-col>
            <v-spacer class="limited-spacer"> </v-spacer>
            <v-col
              :cols="$vuetify.breakpoint.mdAndUp ? 'auto' : '12'"
              class="my-auto"
            >
              <v-select
                v-model="filterId"
                dense
                outlined
                hide-details
                :items="items"
              >
              </v-select>
            </v-col>
          </v-row>
          <v-data-table
            :loading="loading"
            :headers="headers"
            :items="list"
            :footer-props="{
              'items-per-page-options': [10, 25, 50, 100]
            }"
          >
            <template v-slot:item.fullName="{ item }">
              <user-chip :user="item.user"> </user-chip>
            </template>
            <template v-slot:item.userQuestionsComplete="{ item }">
              <v-icon
                :color="item.userQuestionsComplete ? 'success' : 'lighttext'"
              >
                {{ item.userQuestionsComplete ? "check_circle" : "cancel" }}
              </v-icon>
            </template>
            <template v-slot:item.managerQuestionsComplete="{ item }">
              <v-icon
                :color="item.managerQuestionsComplete ? 'success' : 'lighttext'"
              >
                {{ item.managerQuestionsComplete ? "check_circle" : "cancel" }}
              </v-icon>
            </template>
            <template v-slot:item.complete="{ item }">
              <v-icon :color="item.complete ? 'success' : 'lighttext'">
                {{ item.complete ? "check_circle" : "cancel" }}
              </v-icon>
            </template>
            <template v-slot:item.actions="{ item }">
              <v-btn
                text
                class="light-background"
                small
                color="info"
                :to="`/annual-reviews/${item.user.id}`"
              >
                View
              </v-btn>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "AnnualReviewManagerTable",
  components: {},
  data: () => ({
    loading: true,
    headers: [
      { text: "Name", value: "fullName" },
      { text: "Self Review", value: "userQuestionsComplete" },
      { text: "Manager Review", value: "managerQuestionsComplete" },
      { text: "Complete", value: "complete" },
      { text: "Action", value: "actions", sortable: false }
    ],
    filterId: null
  }),
  watch: {
    items(val, oldVal) {
      if (val != oldVal && this.filterId == null && (val || []).length > 0) {
        this.filterId = val[0].value;
      }
    },
    filterId(val, oldVal) {
      if (val != oldVal) {
        this.$emit("filter", val);
      }
    }
  },
  computed: {
    items() {
      return this._.uniqBy(this.annual_reviews, "annualReviewStartDate").map(
        x => ({
          value: x.annualReviewStartDate,
          text: `${this.$options.filters.year(
            x.annualReviewStartDate
          )} Annual Reviews`
        })
      );
    },
    list() {
      let self = this;
      return this._.sortBy(
        this.annual_reviews.filter(
          x => x.annualReviewStartDate == this.filterId
        ),
        function(o) {
          return o.user.id != self.profile.id;
        }
      );
    },
    ...mapGetters({
      annual_reviews: "annualreview/list",
      profile: "profile/profile"
    })
  },
  created() {
    this.loading = true;
    this.$store
      .dispatch("annualreview/getAnnualReviews")
      .catch(error => {
        this.logError(error);
        this.$root.$alert(
          "Error Occurred",
          "An error occured while loading your annual reviews."
        );
      })
      .finally(() => {
        this.loading = false;
      });
  },
  methods: {}
};
</script>
